import { CARD_FRAME_CLASSES } from '../constants/cardConstants';
import { getFrameType } from '@entities/user/ui/UserAvatar';

export const getCardFrameClass = (user, avatarFrame) => {
  const frameType = getFrameType(user, avatarFrame);
  if (!frameType) return '';
  return CARD_FRAME_CLASSES[frameType] || '';
};